import { useEffect } from "react";
import {
  easySupportConfig,
  destroyEasySupport,
  widgetInjectedNodes,
} from "../../services/easySupportService";

const EasySupport = (): null => {
  useEffect(() => {
    if (!easySupportConfig.baseUrl || !easySupportConfig.sdkUrl) {
      console.warn(
        "[EasySupport] Configuration is missing. Skipping widget load.",
        easySupportConfig,
      );
      return;
    }

    let unmounted = false;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          widgetInjectedNodes.push(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: false });

    const script = Object.assign(document.createElement("script"), {
      id: easySupportConfig.widgetScriptId,
      src: easySupportConfig.sdkUrl,
      async: true,
    });

    script.onload = () => {
      if (unmounted) {
        destroyEasySupport();
        return;
      }
      window.EasySupportWidget?.init({
        ...easySupportConfig.initOptions,
        onReady: () => {
          console.log("Customer widget ready");
        },
      });
    };

    script.onerror = () =>
      console.error(
        "[EasySupport] SDK failed to load:",
        easySupportConfig.sdkUrl,
      );

    document.body.appendChild(script);

    return () => {
      unmounted = true;
      observer.disconnect();
      destroyEasySupport();
    };
  }, []);

  return null;
};

export default EasySupport;
